import Image from 'next/image';

import { getImageUrl } from '@shared/utils/getImageUrl/getImageUrl';

import cls from './ResponsiveImage.module.scss';

type ResponsiveImageProps = {
  desktopSrc?: string;
  mobileSrc?: string;
  alt?: string;
  fill?: boolean;
  priority?: boolean;
};

export const ResponsiveImage = ({ desktopSrc, mobileSrc, fill, alt, priority }: ResponsiveImageProps) => {
  const desktopUrl = getImageUrl(desktopSrc);
  const mobileUrl = mobileSrc ? getImageUrl(mobileSrc) : getImageUrl(desktopSrc);
  return (
    <>
      {desktopUrl && (
        <Image
          className={cls.desktop}
          src={desktopUrl}
          fill={fill}
          priority={priority}
          alt={alt || ''}
        />
      )}

      {mobileUrl && (
        <Image
          className={cls.mobile}
          src={mobileUrl}
          fill={fill}
          priority={priority}
          alt={alt || ''}
        />
      )}
    </>
  );
};
